import React, { useEffect, useState } from 'react'
import { Container, Card, Row, Col, Button, Modal } from 'react-bootstrap'
import { useParams, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import Utility from '../../../../GlobalModules/Utility/Utility'
import * as BookingEventsController from '../Controller/BookingEventsController'

const BookingView = (props) => {
  const { slack, lng } = useParams()
  const history = useHistory()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        const res = await BookingEventsController.getBookingDetailApi(slack)
        if (res.success) {
          // console.log('Booking data received:', res.data)
          // console.log('All available fields:', Object.keys(res.data))
          // console.log('no_of_persons value:', res.data?.no_of_persons)
          // Check if data is nested in response.data
          const bookingData = res.data?.data || res.data
          // console.log('Final booking data:', bookingData)
          setData(bookingData)
        }
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [slack])

  const fmt = (v) => Utility.getSafeTimeFormat(v, '-')

  const handleDelete = () => {
    setShowDeleteModal(true)
  }

  const confirmDelete = async () => {
    try {
      setDeleteLoading(true)
      const response = await BookingEventsController.deleteBookingApi(slack)
      if (response.success) {
        Utility.toastNotifications(
          'Booking deleted successfully',
          'Success',
          'success'
        )
        history.push(`/${lng}/booking-events`)
      } else {
        Utility.toastNotifications(
          response.message || 'Failed to delete booking',
          'Error',
          'error'
        )
      }
    } catch (error) {
      Utility.toastNotifications(
        error?.response?.data?.message ||
        error?.message ||
        'Failed to delete booking',
        'Error',
        'error'
      )
    } finally {
      setDeleteLoading(false)
      setShowDeleteModal(false)
    }
  }

  //======= add action permission ====//
  // Check multiple permissions at once
  const bookingViewPermissions = Utility.hasMultipleActionPermissions(
    'bookings_and_calendar',
    'bookings_events',
    ['view', 'create', 'edit', 'delete', 'export', 'approve', 'receive', 'verify', 'reject', 'verify_accept'],
    props?.userCredentials?.user_details?.user_type || ['admin', 'app_admin']
  );

  return (
    <Container fluid className='p-0'>
      <div className='d-flex justify-content-between align-items-center top-header-box'>
        <h4>{data ? `BOOKING ${data.event_code}` : 'Booking'}</h4>
        <div>
          {bookingViewPermissions.delete && (
            <Button
              variant='outline-danger'
              size='sm'
              onClick={handleDelete}
              className='me-2'
            >
              Delete
            </Button>
          )}
          <Button
            variant='outline-secondary'
            size='sm'
            onClick={() => history.push(`/${lng}/booking-events`)}
          >
            Back
          </Button>
        </div>
      </div>

      <Card className='mb-3'>
        <Card.Body>
          <h6 className='mb-3'>Customer Information</h6>
          <Row>
            <Col md={3} className='mb-2'>
              <div className='text-muted small'>Name</div>
              <div>{data?.name || '-'}</div>
            </Col>
            <Col md={3} className='mb-2'>
              <div className='text-muted small'>Email</div>
              <div>{data?.email || '-'}</div>
            </Col>
            <Col md={3} className='mb-2'>
              <div className='text-muted small'>Contact No</div>
              <div>{data?.phone || '-'}</div>
            </Col>
            <Col md={3} className='mb-2'>
              <div className='text-muted small'>No. of Persons</div>
              <div>
                {(() => {
                  console.log('Rendering no_of_persons, data:', data)
                  console.log('no_of_persons value:', data?.no_of_persons)
                  return data?.no_of_persons !== undefined &&
                    data?.no_of_persons !== null
                    ? data.no_of_persons
                    : data?.number_of_persons !== undefined &&
                      data?.number_of_persons !== null
                      ? data.number_of_persons
                      : data?.persons !== undefined && data?.persons !== null
                        ? data.persons
                        : data?.guests !== undefined && data?.guests !== null
                          ? data.guests
                          : data?.people !== undefined && data?.people !== null
                            ? data.people
                            : '-'
                })()}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className='mb-3'>
        <Card.Body>
          <h6 className='mb-3'>Time Information</h6>
          <Row>
            <Col md={6} className='mb-2'>
              <div className='text-muted small'>
                Booking or Event Start Time
              </div>
              <div>{fmt(data?.start_date)}</div>
            </Col>
            <Col md={6} className='mb-2'>
              <div className='text-muted small'>Booking or Event End Time</div>
              <div>{fmt(data?.end_date)}</div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <h6 className='mb-3'>Description</h6>
          <div>{data?.description || '-'}</div>
        </Card.Body>
      </Card>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this booking? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => setShowDeleteModal(false)}
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button
            variant='danger'
            onClick={confirmDelete}
            disabled={deleteLoading}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials
})

export default connect(mapStateToProps)(BookingView)
